import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '@app/core/services/auth.service';
import { SseService } from '@app/core/services/sse.service';

@Component({
  selector: 'pma-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly auth = inject(AuthService);
  private readonly sse = inject(SseService);

  constructor() {
    // Open the single session SSE stream once the user is authenticated, and
    // close it on logout (spec UC-7/VC-8). `connect()` is idempotent, so the
    // effect re-running never opens a second connection; the shell is the only
    // place the stream is opened — never per view.
    effect(() => {
      if (this.auth.isAuthenticated()) {
        this.sse.connect();
      } else {
        this.sse.disconnect();
      }
    });
  }
}
